export enum RolesEnum {
  ROLE_USER = 'ROLE_USER',
  ROLE_CLIENT_ADMIN = 'ROLE_CLIENT_ADMIN',
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_OPERATOR = 'ROLE_OPERATOR',
}

/** Rôles admis dans l'espace joueur `/app` : la garde de la route et l'icône Maison du jeu. */
export const PLAYER_SPACE_ROLES: string[] = [RolesEnum.ROLE_USER, RolesEnum.ROLE_ADMIN];
